var map = {
	"./de": [
		406,
		4
	],
	"./de.json": [
		406,
		4
	],
	"./dummy": [
		407,
		3
	],
	"./dummy.json": [
		407,
		3
	],
	"./en": [
		234
	],
	"./en.json": [
		234
	],
	"./es": [
		408,
		2
	],
	"./es.json": [
		408,
		2
	],
	"./fr": [
		409,
		1
	],
	"./fr.json": [
		409,
		1
	],
	"./ja": [
		410,
		0
	],
	"./ja.json": [
		410,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1043;


//////////////////
// WEBPACK FOOTER
// ./src/locales/bundles async ^\.\/.*$
// module id = 1043
// module chunks = 5